import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import { I as InlineLabel } from './InlineLabel-CklK8gsH.js';
import { T as Text } from './Text-BCmEgJBp.js';

var styles = {"tagWrapper":"_8MYxAQYdZzM-","tags":"WRV-UmQmPzo-","tagsMask":"ND-cN-mX5-c-","tagCount":"liQeWCMenD0-"};

function DataListTags({ items }) {
    const ref = useRef(null);
    const [visibleIndex, setVisibleIndex] = useState([]);
    const visibleItems = visibleIndex.filter(Boolean).length;
    const shouldShowTagCount = Boolean(visibleItems);
    useEffect(() => {
        var _a;
        if (!window.IntersectionObserver)
            return;
        setVisibleIndex([]);
        const observer = new IntersectionObserver(handleIntersection, {
            root: ref.current,
            threshold: buildIntersectionThreshold(items),
        });
        const elements = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll("[data-tag-element]");
        elements === null || elements === void 0 ? void 0 : elements.forEach(element => observer.observe(element));
        return () => {
            elements === null || elements === void 0 ? void 0 : elements.forEach(element => observer.unobserve(element));
        };
    }, [items]);
    return (React.createElement("div", { className: styles.tagWrapper, ref: ref },
        React.createElement("div", { className: classnames(styles.tags, {
                [styles.tagsMask]: shouldShowTagCount,
            }) }, items.filter(Boolean).map((tag, index) => (React.createElement("div", { key: tag, "data-tag-element": index },
            React.createElement(InlineLabel, null, tag))))),
        shouldShowTagCount && (React.createElement("div", { className: styles.tagCount },
            React.createElement(Text, null,
                "+",
                visibleItems)))));
    function handleIntersection(...[entries]) {
        entries.forEach(entry => {
            const index = entry.target.getAttribute("data-tag-element");
            const indexNumber = Number(index);
            if (!index || isNaN(indexNumber))
                return;
            setVisibleIndex(prevState => {
                const newState = [...prevState];
                newState[indexNumber] = entry.intersectionRatio !== 1;
                return newState;
            });
        });
    }
}
function buildIntersectionThreshold(items) {
    const thresholds = [];
    const totalItems = items.length;
    for (let i = 1.0; i <= totalItems; i++) {
        const ratio = i / totalItems;
        thresholds.push(ratio);
    }
    thresholds.push(0);
    return thresholds;
}

export { DataListTags as D };
